import request from "../utils/request";

/** 看板欄位與卡片 */
export function GET_BoardColumns(token, payload) {
  return request.get("/Board/Columns", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 拖拉卡片改狀態 */
export function POST_BoardMove(token, payload) {
  return request.post("/Board/Move", payload, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}
